import { InformationForBorrowingDetailComponent } from "../../../components/borrowSystem/ProposedToTheSubCommittee/InformationForBorrowingDetailComponent";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";

export function InformationForBorrowingDetailContainer () {
    const titleName = "ข้อมูลประกอบการประชุมคณะอนุกรรมการ"; //ใส่ชื่อtitle ตรงนี้
    const subtitle = "พิจารณาการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน"
    return(
        <div className="page-container bg-landing">
            <NavbarBorrowSystem/>
            <HeadTitle title={titleName} subtitle={subtitle} />
            <InformationForBorrowingDetailComponent/>
            <Footer />
        </div>

    )
}




